<template>
    <modal
        :saveAction="save"
        :title="$t(title)"
        :id="id"
        :actionButtons="false"
        size="full"
        :closeButton="true"
        scrollable
        @shown="shown"
        dialogClass="desk32-full-height"
    >
        <div class="row">
            <div class="col-12 col-md-4 col-lg-3 col-xl mb-3">
                <nav
                    class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light"
                    style="position: relative; border-width: 0;"
                >
                    <ul class="navbar-nav mb-md-3">
                        <li class="nav-item" v-for="(navItem, index) in navs" :key="index">
                            <a
                                class="nav-link"
                                href="#"
                                :class="{ active: categoryLocal == navItem.value }"
                                @click.prevent="categoryLocal=navItem.value"
                            >{{ $t(navItem.label) }}</a>
                        </li>
                    </ul>
                </nav>
                <hr />
                <button class="btn btn-white" @click="openModal({id:'cameraModal', multiple:true})">
                    <span class="fe fe-camera"></span>
                    {{$t('Take a photo')}}
                </button>
            </div>
            <div class="col-12 col-md-8 col-lg-9 col-xl-10">
                <uploader :params="{category:categoryLocal}"></uploader>
                <div class="media-modal-images container-fluid">
                    <div class="row">
                        <div class="col small text-muted text-center p-5" v-if="images.length==0">{{$t('Nothing yet')}}</div>
                        <div class="col-6 col-md-4 col-lg-3 col-xl-2" v-else v-for="(image, index) in images" :key="index">
                            <div class="card">
                                <img :src="image.preview" class="card-img-top" v-if="image.preview" />
                                <img :src="image.url" class="card-img-top" v-else />

                                <div class="card-body p-2">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <confirmable-button
                                                style="display:inline;"
                                                buttonClass="btn btn-white btn-sm text-danger"
                                                @confirm="remove(image._id)"
                                            >
                                                <i class="fe fe-trash"></i>
                                            </confirmable-button>
                                        </div>
                                        <div class="col-auto">
                                            <button class="btn btn-white btn-sm text-dark" @click="use(image)">
                                                <span class="fe fe-check"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!-- / .card-body -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <camera-modal :model="model" id="cameraModal"></camera-modal>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { mapActions, mapGetters } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'
import Uploader from '@/components/Uploader.vue';
import CameraModal from '@/components/CameraModal.vue';
import ConfirmableButton from "@/components/ConfirmableButton.vue";

export default {
    name: 'media-modal',
    props: ['id', 'action', 'category'],
    mixins: [modalMixins],
    components: {
        ConfirmableButton,
        Modal,
        Uploader,
        CameraModal
    },
    computed: {
        ...mapGetters('media', {
            findMediaInStore: 'find'
        }),
        images() {
            return this.findMediaInStore(this.params).data;
        },
    },
    watch: {
        categoryLocal(newValue) {
            this.params.query.category = newValue;
            this.fetchMedia();
        }
    },
    data() {
        return {
            categoryLocal: null,
            model: 'another',
            navs: [
                { value: 'profile', label: 'Profile' },
                { value: 'treatments', label: 'Treatments' },
                { value: 'products', label: 'Products' },
                { value: 'customers', label: 'Customers' },
                { value: null, label: 'Others' },
            ],
            errors: null,
            hideForm: false,
            title: 'Media manager',
            params: {
                query: {
                    customerId: null,
                    tags: { $in: ['Images'] },
                    $sort: { createdAt: -1 },
                    category: null

                }
            },
        }
    },
    created() {
        this.fetchMedia();


    },


    methods: {
        ...mapActions('media', ['find', 'remove', 'create']),

        fetchMedia() {
            // console.log(this.params);
            // this.params.query = { customerId: null, tags: { $in: ['Images', 'others'] } };
            this.find(this.params);
        },
        shown() {
            this.categoryLocal = this.category;
        },
        use(image) {
            this.$root.$emit('bv::hide::modal', this.id);
            this.action(image);
        },
        save() {
            this.errors = null;
            this.hideForm = true;
        }
    },

}
</script>

<style lang="scss">
    .desk32-full-height {
        max-height: 100vh;
    }
    .media-modal-images {
        overflow-y: auto;
        height: calc(var(--calculated-vh, 1vh) * 100 - 450px);
    }
    .card-img-top {
        aspect-ratio: 1/1;
        object-fit: contain;
    }
</style>
